import SimpleBar from 'simplebar';

document.querySelectorAll('.teaser-scrollbar').forEach((teaser) => {
  const scrollContainer = document.querySelector('.teaser-scrollbar__content');
  let scroller;

  const update = () => {
    const { top } = document.querySelector('.teaser-scrollbar').getBoundingClientRect();
    const allowScrollDown = (top <= 0);
    if (allowScrollDown) {
      teaser.classList.remove('teaser-scrollbar--no-scroll');
      if (!scroller) {
        scroller = new SimpleBar(scrollContainer, { autoHide: false });
      }
    } else {
      teaser.classList.add('teaser-scrollbar--no-scroll');
      if (scroller) {
        // eslint-disable-next-line no-param-reassign
        teaser.querySelector('.simplebar-content-wrapper').style.overflow = 'hidden';
        scroller.unMount();
        window.setTimeout(() => {
          scroller = null;
        }, 1);
      }
    }
  };

  window.addEventListener('resize', update);
  window.addEventListener('scroll', update);
});
